jQuery(document).ready(function(){
    if( document.getElementById('snack-bundles'))
    {
        var $ = jQuery;
        
        if( $("body").hasClass("payment-details") )
        {
            $('#snack-bundles').remove();
        }
        else
        {
            let actionUrl = '/wp-admin/admin-ajax.php';
        
            let subscriptionBtns = $(".single-subscription");
        
            // add snack bundles to crate btn click event handler
            $('.add-bundle').each( function() {
                $(this).on( 'click', function() {
                    
                    $('.add-bundle').attr('disabled', 'disabled');
        
                    let stripeProductId = $(this).attr("id").replace("add_","");

                    let activeSubBtn = $(".single-subscription.active")[0];

                    let currentBundles = getSubCurrentBundlesAsArray( activeSubBtn );

                    currentBundles.push( stripeProductId );

                    setSubCurrentBundles( activeSubBtn, currentBundles );

                    $(this).attr('disabled', true);
                    $(this).siblings('.remove-bundle:not(.btn-dark)').attr('disabled', false);

                    // show spinner while processing addition of bundle
                    $(this).html(`<div class="spinner-border text-light" role="status">
                    <span class="sr-only">Processing...</span>
                    </div>`);
        
                    let postData = {
                        'action': 'add_bundle',
                        'stripe_product_id': stripeProductId,
                        'post_id': $(this).data("bundle_id"),
                        'subscription_id': $("#stripeSubscriptionForBundle").val(),
                        'payment_id': $("#currentOrderInvoice").val(),
                        'plan': $("#currentOrderPlan").val(),
                        'state': $("#currentOrderState").val(),
                        'zip': $("#currentOrderZip").val(),
                    };

                    submitAjaxForm( actionUrl, postData, $("#add_" + stripeProductId).parent().find('.bundle-err-msg')[0], ".add-bundle" );
                });
            });
            
            // remove snack bundles from crate btn click event handler
            $('.remove-bundle').each( function() {
                $(this).on( 'click', function() {
        
                    let stripeProductId = $(this).attr("id").replace("remove_","");

                    let activeSubBtn = $(".single-subscription.active")[0];
                    
                    let currentBundles = getSubCurrentBundlesAsArray( activeSubBtn );

                    let removeIndex = currentBundles.indexOf( stripeProductId );

                    if( removeIndex !== -1 )
                    {
                        currentBundles.splice( removeIndex, 1 );
                    }

                    setSubCurrentBundles( activeSubBtn, currentBundles,  );

                    $(this).attr('disabled', true);
                    $(this).siblings('.add-bundle').attr('disabled', false);

                    // show spinner while processing removal of bundle
                    $(this).html(`<div class="spinner-border text-light" role="status">
                        <span class="sr-only">Processing...</span>
                    </div>`);
        
                    let postData = {
                        'action': 'remove_bundle',
                        'stripe_product_id': stripeProductId,
                        'post_id': $(this).data("bundle_id"),
                        'subscription_id': $("#stripeSubscriptionForBundle").val(),
                    };
        
                    submitAjaxForm( actionUrl, postData, $("#add_" + stripeProductId).parent().find('.bundle-err-msg')[0] );
                });
            });
        
            $(subscriptionBtns).on('click', function(e){
                let dataset = e.currentTarget.dataset;

                $("#bundleSnackerName").text( $(this).find(".snacker-name").text() + "'s" );
                
                if( dataset.isactive == 0 || dataset.isgift == 1 || dataset.ispaused == 1 || dataset.size.includes('16Snack') || (dataset.billscurrentmonth == 0 && dataset.currentorder == "") )
                {
                    $("#snack-bundles").addClass("d-none");
                }
                else
                {
                    $("#snack-bundles").removeClass("d-none");
                    $(".remove-bundle").addClass("d-none");
                    $(".add-bundle").removeClass("d-none");

                    $("#stripeSubscriptionForBundle").val( dataset.subscription );
                    $("#currentOrderInvoice").val( dataset.currentorder );
                    $("#currentOrderPlan").val( dataset.currentorderplan );
                    $("#currentOrderState").val( dataset.currentorderstate );
                    $("#currentOrderZip").val( dataset.currentorderzip );
                    
                    let purchasedBundles = getSubCurrentBundlesAsArray(e.currentTarget);

                    purchasedBundles.forEach(
                        function(bundle) 
                        {
                            $("#remove_" + bundle).removeClass("d-none");
                            $("#add_" + bundle).addClass("d-none");
                        }
                    );
                }

                if(dataset.currentorder != '')
                {
                    $(".remove-bundle").removeClass("btn-success").addClass("btn-dark").attr("disabled","disabled");
                }
                else
                {
                    $(".remove-bundle").removeClass("btn-dark").addClass("btn-success").removeAttr("disabled");
                }
            });
        }
        // additionally, when bundles are being added/removed we will need to update the bundle's checkbox in /modals/edit-add-ons-modal.php
        // bundles should also be reflected in the .subscription-settings div add-ons line in /template-parts/account-subscription.php
    }
});

function getSubCurrentBundlesAsArray( subscriptionBtn )
{
    return subscriptionBtn.dataset.bundles == '' ?
                            [] : 
                            JSON.parse( subscriptionBtn.dataset.bundles );
}

function setSubCurrentBundles( subscriptionBtn, bundles )
{
    subscriptionBtn.setAttribute( 'data-bundles', JSON.stringify( bundles ) );
}